import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { parsePhoneNumberFromString } from "libphonenumber-js";

import { ActionButtonComponent } from "../../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-account",
	templateUrl: "./account.component.html",
	styleUrls: ["./account.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [FormsModule, ActionButtonComponent, RouterLink]
})
export class AccountComponent implements OnInit {
	private api = inject(ApiService);

	public brand = BrandVars;

	oldpassword = "";
	newpassword = "";
	matchpassword = "";

	smsnumber: string;
	userOptions: any;
	notifyorgs: NotificationOrg[] = [];

	async ngOnInit() {
		const [notifyassets, smsnumber, options] = await Promise.all([
			this.api.GetNotifyAssets(),
			this.api.GetSMSNumber(),
			this.api.GetUserOptions(),
		]);
		const orgs: NotificationOrg[] = [];
		for (const asset of notifyassets) {
			// Add the org and fleet to the bins if necessary
			let org = orgs.find(item => item.organization_name === asset.organization_name);
			if (!org) {
				org = { organization_name: asset.organization_name, fleets: [] };
				orgs.push(org);
			}
			let fleet = org.fleets.find(item => item.fleet_name === asset.fleet_name);
			if (!fleet) {
				fleet = { fleet_name: asset.fleet_name, assets: [] };
				org.fleets.push(fleet);
			}
			// Add the asset to the org's fleet
			fleet.assets.push(asset);
		}
		// Sort the orgs and fleets
		for (const org of orgs) {
			org.fleets.sort((a, b) => a.fleet_name.localeCompare(b.fleet_name));
		}
		orgs.sort((a, b) => a.organization_name.localeCompare(b.organization_name));
		this.notifyorgs = orgs;
		this.smsnumber = smsnumber;
		this.userOptions = options;
	}

	async ChangePassword() {
		try {
			await this.api.ChangePassword(this.oldpassword, this.newpassword);
		} catch (err) {
			if (err.error?.message) {
				throw new Error(err.error.message, { cause: err });
			} else if (err && err.status && err.status === 401) {
				throw new Error("Password incorrect", { cause: err });
			} else {
				throw new Error("Password change failed", { cause: err });
			}
		}
	}

	async UpdateSMS() {
		// First fix the number to the correct format
		const parsed = parsePhoneNumberFromString(this.smsnumber, "US");
		if (!parsed || !parsed.isValid()) {
			throw new Error("Not a valid phone number");
		}
		const fixed = parsed.format("E.164");
		this.smsnumber = fixed;
		await this.api.SetSMSNumber(fixed);
	}

	async UpdateNotifications() {
		await this.api.SetUserOptions(this.userOptions.mute_imports, this.userOptions.mute_commfails);
	}

	async UpdateAssets() {
		const mapped = [];
		for (const org of this.notifyorgs) {
			for (const fleet of org.fleets) {
				for (const asset of fleet.assets) {
					mapped.push([asset.asset_id, asset.enable_email, asset.enable_sms]);
				}
			}
		}
		await this.api.SetNotifyAssets(mapped);
	}
}
export interface NotificationOrg {
	organization_name: string;
	fleets: {
		fleet_name: string;
		assets: APIResults.NotificationAsset[];
	}[];
}